import { Vocabulary } from "../Vocabulary";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import NoCrashIcon from "@mui/icons-material/NoCrash";

export const ROUTER_VEHICULE_GESTIONARE = {
  routes: [
    "/",
    "/vehiclesDashboard",
    "/vehiclesDashboard/vehicleGuarantees/:id?",
    "/vehiclesDashboard/vehicleDetails/:id?",
    "*",
  ],
};

export const MAIN_SLIDER_VEHICULE_GESTIONARE = [
  {
    name: Vocabulary.logsName,
    path: "/logs",
    icon: <AssignmentIndIcon />,
    orderId: 6,
    group: Vocabulary.navGroupAdministration,
  },
];

export const VEHICLE_OPTIONS_VEHICULE_GESTIONARE = [
  {
    name: Vocabulary.detaliiVehicul,
    path: "/vehiclesDashboard/vehicleDetails/",
    icon: <NoCrashIcon />,
    id: "vehicleDetails",
    orderNumber: 1,
  },
];

export const DINAMIC_TABS_VEHICULE_GESTIONARE = null;

export const MAIN_TABLE_VEHICULE_GESTIONARE = null;
